// src/components/insights/Image.jsx

function Image({
  src,
  caption,
  variant = "photo",
}) {
  return (
    <div className={`article-image article-image-${variant}`}>
      <img src={src} alt={caption} />

      {caption && (
        <div className="article-image-caption">
          {caption}
        </div>
      )}
    </div>
  );
}

export default Image;